<template>
  <Page class="queryView">
    <div class="queryView-main">
      <div style="display:flex;width:100%">
        <a-form class="flex-form" style="flex: 1" layout="inline" :form="form" :colon="false">
          <div class="grid grid-cols-2 xl:grid-cols-3">
            <a-form-item label="产品名称">
              <a-input
                :max-length="64"
                allow-clear
                v-decorator="['searchWord']"
                placeholder="请输入产品名称"
                @pressEnter="doQuery()"
              ></a-input>
            </a-form-item>
            <a-form-item label="出发地">
              <a-input
                :max-length="64"
                allow-clear
                v-decorator="['portOfDeparture']"
                placeholder="请输入出发地"
                @pressEnter="doQuery()"
              ></a-input>
            </a-form-item>
            <a-form-item label="目的地">
              <a-input
                :max-length="64"
                allow-clear
                v-decorator="['destination']"
                placeholder="请输入目的地"
                @pressEnter="doQuery()"
              ></a-input>
            </a-form-item>
          </div>
        </a-form>
        <div style="flex: 1"></div>
        <div style="text-align: right">
          <a-button class="app-btn" type="primary" ghost style="margin-right: 20px;" @click="doQuery()">
            立即搜索
          </a-button>
          <a-button class="app-btn" type="default" style="margin-right: 40px;" @click="resetAndQuery$qv">
            重置搜索
          </a-button>
        </div>
      </div>

      <a-table
        class="mt-5"
        :row-key="
          (record, index) => {
            return index
          }
        "
        bordered
        :loading="tableLoading"
        :columns="tableColumns"
        :dataSource="dataSource"
        @change="handleTableChange$qv"
        :pagination="{
          current: pageNumber,
          pageSize: pageSize,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }"
      />
    </div>
    <a-modal v-model="mapModelVisible" title="查看" :width="400" @cancel="handleCancel" @ok="handleOk">
      <img :src="modalImageCode" style="width: 100%;min-height:200px" alt="" />
    </a-modal>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'

export default {
  mixins: [queryViewMixin, toolMixin],
  components: {
    Page,
    PictureCardUpload,
  },
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '80px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '产品名称',
        align: 'center',
        dataIndex: 'productName',
      },
      {
        title: '直客价格',
        align: 'center',
        dataIndex: 'customerPrice',
      },
      {
        title: '同业价格',
        align: 'center',
        dataIndex: 'businessPrice',
      },
      {
        title: '结算价格',
        align: 'center',
        dataIndex: 'settlementPrice',
      },

      {
        title: '出发口岸',
        align: 'center',
        dataIndex: 'portOfDepartureChi',
      },
      {
        title: '出发城市',
        align: 'center',
        dataIndex: 'productCityChi',
      },
      {
        title: '操作',
        width: '220px',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex justify-center gap-5 text-primary-500">
              <a
                class="text-primary-500"
                onClick={() => {
                  this.checkSee(row)
                }}
              >
                查看
              </a>
              <a
                class="text-primary-500"
                onClick={() => {
                  this.checkLink(row)
                }}
              >
                复制小程序地址
              </a>
            </div>
          )
        },
      },
    ]
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      },
      form: this.$form.createForm(this),
      modalTitle: '添加产品',
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      addGuideType: false,
      tableColumns: tableColumns,
      dataSource: [],
      modalImageCode: '',
      mapModelVisible: false,
    }
  },
  methods: {
    handleOk() {
      this.mapModelVisible = false
    },
    async updateStatus(row) {
      console.log('row', row)
      this.modalImageCode = ''
      this.modalImageCode = row.wechatMiniCode
      this.mapModelVisible = true
    },
    handleAdd() {
      this.$router.push({
        path: '/m/scopeMain/travelProduct/productDetail',
      })
    },
    checkSee(row) {
      this.$router.push({
        path: '/m/scopeMain/travelProduct/productDetail',
        query: { travelCode: row.travelCode },
      })
    },
    async checkLink(row) {
      const text = `/pages/travel/detail?travelCode=${row.travelCode}`
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('复制成功')
      } catch (err) {
        // 降级方案
        this.copyTextFallback(text)
      }
    },

    copyTextFallback(text) {
      // 使用方法1的实现
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('复制成功')
      } catch (err) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(textarea)
    },
    getParams() {
      const params = this.form.getFieldsValue()
      return {
        ...params,
      }
    },
    async doQuery(page) {
      if (page) {
        this.pageNumber = page
      }
      this.tableLoading = true
      const res = await this.$axios.get('/po/admin/travel/product/list', {
        params: {
          page: this.pageNumber,
          limit: this.pageSize,
          ...this.getParams(),
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    handleCancel() {
      this.mapModelVisible = false
    },
    handlerMap({ BMap, map }) {
      this.map = map
    },
    // -------------------------method end.--------------------------------
  },
  async mounted() {
    this.doQuery()
  },
}
</script>
<style lang="less" scoped>
.bm-view {
  height: 600px;
}
</style>
